// @flow

import R from 'ramda';
import debugLib from 'debug';
import { reducerWrapper } from '../support/utils';

import type {
  FlipperReducer as FlipperState,
  FlipperAction
} from '../types/flipperTypes';

import {
  FLIPPER_ON,
  FLIPPER_OFF,
  FLIPPER_HYDRATE
} from '../actions/FlipperActions';
const debug = debugLib('FlipperReducer');

const INIT_STATE: FlipperState = {
  loading: false,
  error: null,
  featuresSaved: {},
  features: {}
};

export function createInitialState(): FlipperState {
  return {
    loading: false,
    error: null,
    featuresSaved: {},
    features: {}
  };
}

function hydrate(state: FlipperState, action: FlipperAction): FlipperState {
  if (!state) {
    return INIT_STATE;
  }

  if (typeof window === 'undefined') {
    debug('Window object not found');
    return state;
  }

  const features =
    (window.App && window.App.context && window.App.context.flipper) || {};
  debug('Hydrate: ', features);
  return {
    ...state,
    features: {
      ...features
    }
  };
}

function Handler(state: FlipperState, action: FlipperAction) {
  switch (action.type) {
    case FLIPPER_ON.response:
      debug('Receive action type', action.type);
      return R.merge(state, {
        loading: false,
        error: false,
        featuresSaved: { ...state.featuresSaved, [action.data]: 'on' }
      });
    case FLIPPER_OFF.response:
      debug('Receive action type', action.type);
      return R.merge(state, {
        loading: false,
        error: false,
        featuresSaved: { ...state.featuresSaved, [action.data]: 'off' }
      });
    case FLIPPER_HYDRATE:
      return hydrate(state, action);

    default:
      return state;
  }
}

const FlipperUpdates = reducerWrapper(INIT_STATE, Handler, {
  request: [FLIPPER_ON, FLIPPER_OFF],
  error: [FLIPPER_ON, FLIPPER_OFF],
  resetOn: ['APP_CHANGE']
});

export default FlipperUpdates;
